import AlertTopPanelDetails from './AlertTopPanelDetails';
import PartyIdentity from './PartyIdentity';
import AlertAssocCustomers from './AlertAssocCustomers';
import TransactionDetails from './TransactionDetails';
import LoanDetails from './LoanDetails';

export default {
  AlertTopPanelDetails,
  PartyIdentity,
  AlertAssocCustomers,
  TransactionDetails,
  LoanDetails
};
